import { Community } from "../../models";

export interface CommunityListResult {
  communities: Community[];
  communityCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
